import { createContext, use, type ReactNode } from 'react'

/**
 * What the app puts at the top of the stack's ROOT screen — its own bar, on a phone.
 *
 * It rides inside level 0 rather than sitting over the stage, so the push covers it and the pop reveals it as
 * part of the travel itself: it is the screen moving, not a second thing timed to agree with it. The stack
 * stays generic — it renders whatever the shell handed it and knows nothing about the app's chrome.
 */
const RootChromeContext = createContext<ReactNode>(null)

export function RootChromeProvider(props: { chrome: ReactNode; children: ReactNode }) {
  return <RootChromeContext value={props.chrome}>{props.children}</RootChromeContext>
}

export function useRootChrome(): ReactNode {
  return use(RootChromeContext)
}
